import { ApiClient, objectToQueryString } from '../ApiClient';
class BlogApiClient {
    constructor() {
        this.apiClient = new ApiClient('/api/blog');
    }
    async searchArticles(query, abort) {
        return await this.apiClient.get(`/articles?${objectToQueryString(query)}`, abort);
    }
}
const blogApiClient = new BlogApiClient();
export default blogApiClient;
